// extracted by mini-css-extract-plugin
export default {"root":"UsageAnalyticsPage_root__GwtJw","body":"UsageAnalyticsPage_body__BRqVY","row":"UsageAnalyticsPage_row__Uq3Ma"};